import React from "react"

function EventStartPage() {
  return <div>EventStartPage</div>
}

export default EventStartPage
